import React, {useEffect, useRef} from 'react';
import {useTranslation} from 'react-i18next';

import Loader from 'components/Loader';
import useFields from 'components/Form/hooks/useFields';
import useItem from 'components/Form/hooks/useItem';
import ParserRestApi from 'helpers/ParserRestApi';

function Form(props) {
	const mountedRef = useRef()
	const {t} = useTranslation();
	let {
		hook = false,
		keyWatch = 'item',
		id = false,
		title = false,
		inputs = [],
		hooksForm = {},
		injectData = {},
		hideBtn = false
	} = props;


	const data = typeof hook === 'function' ? hook() : injectData;


	const {
		setItem,
		updateItem,
		item,
		validate,
		errors,
		getDefaultValue
	} = useItem(inputs);

	const isCreate = typeof item['@id'] === 'undefined';

	const {
		fields
	} = useFields(
		inputs,
		{
			updateItem,
			item,
			errors
		}
	);

	const afterSave = (d) => {
		if (typeof hooksForm.afterSave === 'function') {
			hooksForm.afterSave(d);
		}
	}

	const save = () => {
		if (validate() == false) {
			return;
		}
		if (isCreate) {
			let finalItem = {...item};
			delete finalItem.id;
			data.launchMethod('save', [finalItem, afterSave]);
		} else {
			let finalItem = {...item};
			inputs.map((input) => {
				if (typeof finalItem[input.name] === 'object' && typeof finalItem[input.name]['@id'] !== 'undefined') {
					finalItem[input.name] = finalItem[input.name]['@id'];
				}
				if (typeof finalItem[input.name] === 'array') {
					let newArray = finalItem[input.name].map((value) => {
						return typeof value['@id'] !== 'undefined' ? value['@id'] : value;
					});
					finalItem[input.name] = newArray;
				}
			});
			data.launchMethod('update', [ParserRestApi.parseId(item['@id']), finalItem, afterSave]);
		}
	}

	useEffect(() => {
		if (mountedRef.current) {
			if (data.item && data.item.loaded && Object.keys(data.item.props).length > 0) {
				setItem(data.item.props);
			}
		}
	}, [data.item])


	useEffect(() => {
		if (mountedRef.current) {
			data.launchMethod('change', [item]);
		}
	}, [item])

	useEffect(() => {
		mountedRef.current = true
	}, [])

	useEffect(() => {
		if (mountedRef.current) {
			if (typeof data.launchMethod === 'function') {
				data.launchMethod('fetchOnce', [id, () => {
				}, getDefaultValue()]);
				if (typeof hook !== 'function') {
					if (data.item && data.item.loaded && Object.keys(data.item.props).length > 0) {
						setItem(data.item.props);
					}
				}
			}
		}
	}, [id]);

	return (
		<section className="scroll-section" id="stripedRows">
			{title && (<h2 className="small-title">{title}</h2>)}
			{data[keyWatch].fetching && (
				<Loader />
			)}
			{
				(data[keyWatch].loaded) && (
					<>
						<div className="row">
							{inputs.map((input, indexInput) => {
								let {
									type = 'input',
									label = false
								} = input;

								let isError = errors.indexOf(input.name) !== -1;
								let onValide = errors.length > 0;
								if (type === 'group') {
									return (
										<div className="mb-3" key={'input' + indexInput}>
											{label && (<h2 className="small-title">{label}</h2>)}
											<div className="row">
												{
													input.items.map((item, indexItem) => {
														let {
															type: typeItem = 'input',
															size = '',
															className = "",
															img = (null)
														} = item;


														if (img) {
															className += ' input-with-img';
														}
														if (size !== '') {
															size = '-' + size;
														}
														return (
															<div
																className={'col' + size + ' ' + className}
																key={'input' + indexInput + '-' + indexItem}
															>
																{typeof fields[typeItem] !== 'undefined' && fields[typeItem]({
																	...item,
																	isError,
																	onValide
																})}
															</div>
														);

													})
												}
											</div>
										</div>
									);
								}
								return (
									<div key={'input' + indexInput}>
										{typeof fields[type] !== 'undefined' && fields[type]({
											...input,
											isError,
											onValide
										})}
									</div>
								);
							})}
						</div>
						{hideBtn === false && (
							<div className="col-12">
								<button
									onClick={save}
									className="btn btn-primary"
									type="submit">
									{t(isCreate ? 'Form.add' : 'Form.update')}
								</button>
							</div>
						)}
					</>
				)}
		</section>
	);
}

export default Form;
